import { Injectable } from '@angular/core';
import { WguOauth2Service } from '@wgu-edu/oauth2';
import { EnvironmentService } from './environment.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthConfig } from '../models/environment';
import { UserTypes } from '../models/userTypes';
import { AUTH_CLIENT_KEY, USER_TYPE } from '../models/constants';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  authenticated: boolean = false;
  isEvaluator: boolean = false;
  decodedJWT!: any;
  userType: string = '';
  clientId: string = '';
  bannerId: string = '';
  roles: string[] = [];
  authClient: AuthConfig;

  constructor(
    private envService: EnvironmentService,
    private wguAuthService: WguOauth2Service,
    private jwtHelper: JwtHelperService,
  ) {
      let clientString = sessionStorage.getItem(AUTH_CLIENT_KEY);
      if (clientString === null){
        const authString = this.configureAuthClient();
        this.authClient = authString ? JSON.parse(authString) : {};
      }else{
        this.authClient = JSON.parse(clientString);
      }
  }

  configureAuthClient():string{
  const path = globalThis.location.pathname;
    var client = UserTypes.EMA;
    if(path.toLowerCase().includes('sam')){
      client =  UserTypes.SAM;
    }
    let authString = "";
    if(client == UserTypes.SAM){
      sessionStorage.setItem(USER_TYPE, UserTypes.SAM);
      const samConfig = this.envService.environment?.authConfig?.sam;
      authString = samConfig ? JSON.stringify(samConfig) : "";
    } else {
      sessionStorage.setItem(USER_TYPE, UserTypes.EMA);
      const emaConfig = this.envService.environment?.authConfig?.ema;
      authString = emaConfig ? JSON.stringify(emaConfig) : "";
    }
    if (authString) {
      sessionStorage.setItem(AUTH_CLIENT_KEY, authString);
    }
    return authString;
  }

  getDecodedJWT() {
    return this.decodedJWT;
  }

  getUserType(){
    return this.userType;
  }

  getBannerId(){
    if (this.bannerId === undefined){
      return "";
    }
    return this.bannerId;
  }

  getIsEvaluator(){
    return this.isEvaluator;
  }

  isAuthenticated(){
    return this.authenticated;
  }

  startAuthentication(): void {
    console.log('start auth');
    this.wguAuthService.init(this.authClient);
    if (this.wguAuthService && !this.authenticated) {
      this.wguAuthService.start().then(() => {
        this.authenticated = this.wguAuthService.isAuthenticated();
        if (this.authenticated) {
          console.log('authenticated');
          this.getTokenDecoded();
        }
      });
    } else {
      console.log('authenticated');
      this.getTokenDecoded();
    }
  }  

  getWguoauth2(): string {
    const value = sessionStorage.getItem('wgu-oauth2');
    if(value === null) {
      return '';
    } else {
      return value;
    }
  }

  getTokenDecoded() {
    try {
      const tokenString = this.getWguoauth2();
      if (!tokenString) {
        console.log('No token available');
        return;
      }
      
      const token = JSON.parse(tokenString);
      this.decodedJWT = this.jwtHelper.decodeToken(token.access_token);
      console.log("token:", this.decodedJWT);
      this.userType = this.decodedJWT['type'];
      this.clientId = this.decodedJWT['client_id'];
      this.bannerId = this.decodedJWT['banner_id'];

      const wgu_role_one = this.decodedJWT['wgu_role_one'];
      const wgu_role_two = this.decodedJWT['wgu_role_two'];
      const roles:any[] = this.decodedJWT['roles'];
      console.log(roles);

      if (wgu_role_one){
        this.isEvaluator = wgu_role_one.includes('Employee') || wgu_role_one.includes('Staff')
        || wgu_role_two.includes('Employee') || wgu_role_two.includes('Staff');
      }
      else if (roles){
        this.isEvaluator = roles.includes('NGP_Staff') || roles.includes('NGP_Evaluator');
      }

  globalThis.sessionStorage.setItem('currentPerson', JSON.stringify({ wguId: this.bannerId }));
    } catch (error) {
      console.error('Error decoding token', error);
      this.decodedJWT = undefined;
      this.userType = '';
      this.clientId = '';
      this.bannerId = '';
      this.isEvaluator = false;
    }
  }
}
